__turbopack_context__.v({
  "active": "page-module__fRddnW__active",
  "addToCart": "page-module__fRddnW__addToCart",
  "benefit": "page-module__fRddnW__benefit",
  "benefits": "page-module__fRddnW__benefits",
  "breadcrumb": "page-module__fRddnW__breadcrumb",
  "capsuleDisplay": "page-module__fRddnW__capsuleDisplay",
  "category": "page-module__fRddnW__category",
  "current": "page-module__fRddnW__current",
  "description": "page-module__fRddnW__description",
  "detailItem": "page-module__fRddnW__detailItem",
  "detailLabel": "page-module__fRddnW__detailLabel",
  "detailValue": "page-module__fRddnW__detailValue",
  "details": "page-module__fRddnW__details",
  "featuredBadge": "page-module__fRddnW__featuredBadge",
  "flavorNotes": "page-module__fRddnW__flavorNotes",
  "flavorTag": "page-module__fRddnW__flavorTag",
  "imageColumn": "page-module__fRddnW__imageColumn",
  "imageThumbnail": "page-module__fRddnW__imageThumbnail",
  "infoColumn": "page-module__fRddnW__infoColumn",
  "intensityBar": "page-module__fRddnW__intensityBar",
  "intensityBlock": "page-module__fRddnW__intensityBlock",
  "intensityHeader": "page-module__fRddnW__intensityHeader",
  "intensityMeter": "page-module__fRddnW__intensityMeter",
  "intensityValue": "page-module__fRddnW__intensityValue",
  "mainImage": "page-module__fRddnW__mainImage",
  "notFound": "page-module__fRddnW__notFound",
  "page": "page-module__fRddnW__page",
  "perUnit": "page-module__fRddnW__perUnit",
  "price": "page-module__fRddnW__price",
  "priceRow": "page-module__fRddnW__priceRow",
  "productGrid": "page-module__fRddnW__productGrid",
  "productName": "page-module__fRddnW__productName",
  "productSection": "page-module__fRddnW__productSection",
  "quantitySelector": "page-module__fRddnW__quantitySelector",
  "relatedGrid": "page-module__fRddnW__relatedGrid",
  "relatedSection": "page-module__fRddnW__relatedSection",
  "spin": "page-module__fRddnW__spin",
  "spinner": "page-module__fRddnW__spinner",
});
